import React from 'react';
import { useState } from 'react';
import { ENDPOINT, setToken } from '../utils/constants';

export const Login = (props: { setUser: (user: any) => void }) => {
    const [state, setState] = useState({
        loading: false,
        userName: '',
        password: ''
    });

    const logIn = () => {
        setState({ ...state, loading: true });

        fetch(`${ENDPOINT}/login`, {
            headers: {
                'Content-Type': 'application/json'
            },
            method: 'POST',
            body: JSON.stringify({
                userName: state.userName,
                password: state.password
            })
        })
            .then((res) => {
                if (res.status !== 200) {
                    throw new Error();
                }

                return res.json();
            })
            .then((res) => {
                const { user, token } = res;
                localStorage.setItem('user_planning', token);
                setToken(token);
                props.setUser(user);
            })
            .catch(() => setState({ ...state, loading: false }));
    };

    return (
        <div className="login">
            <div className="form-wrap">
                <div className="form-container">
                    <div className="form-content">
                        <h1>Login</h1>
                        <p>Log in to your account to continue.</p>
                        <div className="form-login">
                            <div className="form-group">
                                <label>Username</label>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="feather feather-user"
                                >
                                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                                    <circle cx="12" cy="7" r="4"></circle>
                                </svg>
                                <input
                                    value={state.userName}
                                    onChange={(e) => setState({ ...state, userName: e.target.value })}
                                    type="text"
                                    className="form-control-login"
                                />
                            </div>
                            <div className="form-group">
                                <label>Password</label>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="feather feather-lock"
                                >
                                    <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                                    <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                                </svg>
                                <input
                                    value={state.password}
                                    onChange={(e) => setState({ ...state, password: e.target.value })}
                                    type="password"
                                    className="form-control-login"
                                />
                            </div>
                            <button className="login-btn" onClick={logIn}>
                                Log In
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
